import clsx from 'clsx'

export default (...classes) => (
    clsx(classes).replace('undefined', '').replace('  ', ' ')
)
